export default {"src":"/_next/static/media/clarifayo_fundoAzul2.d202ea2d.svg","height":704,"width":432,"blurWidth":0,"blurHeight":0};